export const GroupTypes = {
  UNKNOWN: "unknown",
  INTERNAL_GLOBALS: "internal_globals",
  INTERNAL_FUNCTIONS: "internal_functions",
  TO_GLOBALS: "to_globals",
  TO_FUNCTIONS: "to_functions",
};
